/* globals process */

import { adminApi } from '@admin/redux/adminApi';
import { configureStore, PreloadedState } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';

import { broadbandApi } from '../../../Broadband/js/redux/broadbandApi';
import rootReducer, { RootState } from './rootReducer';

export const store = configureStore({
    preloadedState: <PreloadedState<RootState>>{
        broadband: {}
    },
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(broadbandApi.middleware).concat(adminApi.middleware)
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

export const { dispatch, getState, subscribe } = store;
